import {
    Form, FormButton, FormButtonContainer, FormErrors, FormItem, FormSubmitHandler, TextInput, useAlerts, useForm,
} from "@sis/react-library"
import { DepartmentDto } from "./FormSamplesFormGroupsPage";
import { FormSamplesFormGroupsFGPerson } from "./FormSamplesFormGroupsFGPerson";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends DepartmentDto { }

interface FormSamplesFormGroupsFormProps {
    initialValues: DepartmentDto;
    onSubmit: FormSubmitHandler<DepartmentDto>;
    submitting: boolean;
}

export const FormSamplesFormGroupsForm = ({
    initialValues, onSubmit, submitting
}: FormSamplesFormGroupsFormProps) => {

    const formName = 'FormFormGroups';

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            initialValues={initialValues}  // Pass through the initial values of the form
            beforeLeaveText='You have made changes, are you sure you want to leave ?'            
            /////////////////////////////////////////////////////////////////////////////////
            // additionalItems is where you can create extra items for the form to keep
            // track of where there's no user input.
            // This is where we keep the id so it can be submitted as part of the form.
            /////////////////////////////////////////////////////////////////////////////////
            additionalItems={[{ name: "departmentId" }]}
        >
            <FormItem<T>
                formField="departmentDesc"
                label="Department"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="manager"
                label="Manager"
                element={<FormSamplesFormGroupsFGPerson heading="Manager" />}
            />
            <FormItem<T>
                formField="supervisor"
                label="Supervisor"
                element={<FormSamplesFormGroupsFGPerson heading="Supervisor" />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
            <FormErrors forFormErrors />
        </Form>
    )
}
